export default {
  // Navigation
  'nav.timer': 'টাইমার',
  'nav.stopwatch': 'স্টপওয়াচ',
  'nav.worldclock': 'বিশ্ব ঘড়ি',
  'nav.timestamp': 'টাইমস্ট্যাম্প',
  'nav.home': 'হোম',

  // Common buttons and actions
  'button.start': 'শুরু করুন',
  'button.pause': 'পজ করুন',
  'button.stop': 'থামান',
  'button.reset': 'পুনরায় সেট করুন',
  'button.ok': 'ঠিক আছে',
  'button.cancel': 'বাতিল করুন',
  'button.close': 'বন্ধ করুন',
  'button.save': 'সংরক্ষণ করুন',
  'button.delete': 'মুছে ফেলুন',
  'button.edit': 'সম্পাদনা করুন',
  'button.back': 'ফিরে যান',
  'button.next': 'পরবর্তী',
  'button.previous': 'পূর্ববর্তী',
  'button.submit': 'জমা দিন',
  'button.confirm': 'নিশ্চিত করুন',
  'button.convert': 'রূপান্তর করুন',
  'button.copy': 'অনুলিপি করুন',
  'button.copied': 'অনুলিপি করা হয়েছে!',
  'button.now': 'এখনই',
  'button.clear': 'পরিষ্কার করুন',

  // Common labels
  'label.hours': 'ঘন্টা',
  'label.minutes': 'মিনিট',
  'label.seconds': 'সেকেন্ড',
  'label.milliseconds': 'মিলিসেকেন্ড',
  'label.minute': 'মিনিট',
  'label.second': 'সেকেন্ড',
  'label.sound': 'শব্দ',
  'label.soundAlert': 'শব্দ',
  'label.fullscreen': 'পূর্ণ স্ক্রিন',
  'label.language': 'ভাষা',
  'label.selectLanguage': 'ভাষা নির্বাচন করুন',
  'label.languageSelectorInfo': 'বর্তমানে {{count}}টি ভাষা সমর্থন করে। উপরের বিকল্পগুলি থেকে আপনার পছন্দের ভাষা নির্বাচন করুন।',

  // Common messages
  'message.timerComplete': 'টাইমার সম্পন্ন!',
  'message.timerCompleteDesc': 'আপনার টাইমার সম্পন্ন হয়েছে',
  'message.timerCompleteBody': 'আপনার কাউন্টডাউন টাইমার সম্পন্ন হয়েছে!',
  'message.stopwatchStarted': 'স্টপওয়াচ শুরু হয়েছে',
  'message.stopwatchStartedDesc': 'স্টপওয়াচ টাইমিং শুরু হয়েছে',
  'message.stopwatchStopped': 'স্টপওয়াচ থেমে গেছে',
  'message.stopwatchStoppedDesc': 'স্টপওয়াচ টাইমিং বিরতি দেওয়া হয়েছে',
  'message.stopwatchReset': 'স্টপওয়াচ পুনরায় সেট হয়েছে',
  'message.stopwatchResetDesc': 'স্টপওয়াচ শূন্যে পুনরায় সেট করা হয়েছে',
  'message.notificationPermission': 'টাইমার সম্পন্ন হলে সতর্কতা পেতে বিজ্ঞপ্তি অনুমতি দিন',
  'message.clickToEdit': 'সময় সরাসরি সম্পাদনা করতে সময় সংখ্যায় ক্লিক করুন',
  'message.addHours': '+ ঘন্টা যোগ করুন',
  'message.escToExit': 'পূর্ণ স্ক্রীন থেকে বেরিয়ে আসতে ESC টিপুন',
  'message.timeRemaining': '{{minutes}} মিনিট {{seconds}} সেকেন্ড বাকি',
  'message.minutesRemaining': '{{minutes}} মিনিট বাকি',
  'message.secondsRemaining': '{{seconds}} সেকেন্ড বাকি',
  'message.stopwatchTimeElapsed': '{{minutes}} মিনিট {{seconds}} সেকেন্ড অতিক্রম করেছে',
  'message.stopwatchMinutesElapsed': '{{minutes}} মিনিট অতিক্রম করেছে',
  'message.stopwatchSecondsElapsed': '{{seconds}} সেকেন্ড অতিক্রম করেছে',
  'message.invalidTimestamp': 'অবৈধ টাইমস্ট্যাম্প',
  'message.invalidDateTime': 'অবৈধ তারিখ এবং সময়',
  'message.conversionError': 'রূপান্তর ত্রুটি',

  // Time units
  'time.am': 'পূর্বাহ্ন',
  'time.pm': 'অপরাহ্ন',
  'time.now': 'এখনই',
  'time.today': 'আজ',
  'time.yesterday': 'গতকাল',
  'time.tomorrow': 'আগামীকাল',

  // Common errors
  'error.pageNotFound': 'পৃষ্ঠা পাওয়া যায়নি',
  'error.somethingWrong': 'কিছু ভুল হয়েছে',
  'error.tryAgain': 'অনুগ্রহ করে পরে আবার চেষ্টা করুন',

  // Footer
  'footer.about': 'timer.today সম্পর্কে',
  'footer.aboutDesc': 'timer.today একটি পেশাদার অনলাইন টাইমিং টুল প্ল্যাটফর্ম যা তিনটি মূল বৈশিষ্ট্য প্রদান করে:',
  'footer.timerDesc': 'কাস্টমাইজযোগ্য কাউন্টডাউন টুল যা মিনিট এবং ঘন্টা সেটিংস সমর্থন করে, কাজের ফোকাস, রান্নার সময়, অধ্যয়ন পরিচালনা এবং আরও অনেক কিছুর জন্য নিখুঁত। শব্দ সতর্কতা এবং ডেস্কটপ বিজ্ঞপ্তি বৈশিষ্ট্য রয়েছে।',
  'footer.stopwatchDesc': 'মিলিসেকেন্ড নির্ভুলতা সহ উচ্চ নির্ভুলতা টাইমিং টুল, ক্রীড়া প্রশিক্ষণ, রান্নার ক্রিয়াকলাপ, পরীক্ষার অনুশীলন এবং সুনির্দিষ্ট টাইমিং প্রয়োজনীয় অন্যান্য পরিস্থিতির জন্য উপযুক্ত।',
  'footer.worldClockDesc': 'বিশ্বব্যাপী প্রধান শহরগুলির সময় রিয়েল-টাইম প্রদর্শন বুদ্ধিমান টাইম জোন গণনা সহ, আন্তর্জাতিক ব্যবসায়িক যোগাযোগ এবং ক্রস-টাইমজোন সহযোগিতা সহজ করে।',
  'footer.timestampDesc': 'ইউনিক্স টাইমস্ট্যাম্প কনভার্টার টাইমস্ট্যাম্প এবং ডেটটাইমের মধ্যে দ্বিমুখী রূপান্তর সমর্থন করে, সেকেন্ড এবং মিলিসেকেন্ড উভয় ফর্ম্যাট সমর্থন সহ।',
  'footer.termsOfService': 'সেবার শর্তাবলী',
  'footer.privacy': 'গোপনীয়তা',
  'footer.contactUs': 'আমাদের সাথে যোগাযোগ করুন',
  'footer.changeLanguage': 'ভাষা পরিবর্তন করুন',
  'footer.moreLanguage': 'আরও ভাষা',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 সেকেন্ড',
  'quick.add1min': '+1 মিনিট',
  'quick.add5min': '+5 মিনিট',
  'quick.add10min': '+10 মিনিট',
  'quick.add30min': '+30 মিনিট',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}} মিনিট টাইমার',
  'breadcrumb.timer': 'টাইমার',
  'breadcrumb.stopwatch': 'স্টপওয়াচ',
  'breadcrumb.worldClock': 'বিশ্ব ঘড়ি',
  'breadcrumb.termsOfService': 'সেবার শর্তাবলী',
};